import { takeEvery, fork, put, all, call } from "redux-saga/effects"

import { EDIT_PROFILE, EDIT_AVATAR, EDIT_LOGIN } from "./actionTypes"
import { profileSuccess, profileError } from "./actions"
import { loginUpdate, loginSuccess } from "../login/actions"

import BizinBackend from "../../../helpers/bizin_helper";

function* editAvatar({ payload: { user } }) {
  try {
    const paramsData = {
      ID_Usuario:      user.ID_Usuario,
      Cultura_Idioma:  user.Cultura_Idioma,      
      Foto_Usuario:    user.Foto_Usuario,
    };

    const resp = yield call(
      BizinBackend.executeProcedure,
      paramsData,
      "FRONT_Workspace_Atualizar_Foto_Usuario",
      user._csrf,
      user._access_token_msman,
    );

    const message =
        resp.resultset_2?.[0]?.message
        ?? "Alterações salvas com sucesso!";

    const updatedUser = resp.resultset_1?.[0];
    
    if (!updatedUser) {     
      const respErro = resp[0]?.message ?? "Resposta inválida do servidor";
      throw new Error(respErro);      
    }

    const raw = localStorage.getItem("authUser");    
    const prev = raw ? JSON.parse(raw) : {};

    const merged = {
      ...prev,
      resultset_2: [ updatedUser ]
    };

    localStorage.setItem("authUser", JSON.stringify(merged));
    
    yield put(loginUpdate(updatedUser));

    yield put(profileSuccess(message));

  } catch (err) {
    const message =
      (typeof err.response?.data === "string" && err.response.data.trim()) ||
      err.response?.data?.message ||
      JSON.stringify(err.response?.data) ||
      err.message ||
      String(err);
    
    yield put(profileError(message));
  }
}

function* editProfile({ payload: { user } }) {
  try {

    const paramsData = {
      ID_Usuario:      user.ID_Usuario,
      Cultura_Idioma:  user.Cultura_Idioma,
      Nome_Completo:   user.Nome_Completo,
      Apelido:         user.Apelido,
      EMAIL:           user.Email,
      Celular:         user.Celular,
      Telefone:        user.Telefone,
      CPF:             user.CPF,
      Data_Nascimento: user.Data_Nascimento,
      ID_Departamento: user.ID_Departamento,
      ID_Cargo:        user.ID_Cargo,
      ID_Idioma:       user.ID_Idioma,
    };

    const resp = yield call(
      BizinBackend.executeProcedure,
      paramsData,
      "FRONT_Workspace_Atualizar_Dados_Usuario",
      user._csrf,
      user._access_token_msman
    );

    const message = resp.resultset_2?.[0]?.message ?? "Alterações salvas com sucesso!";      

    const updatedUser = resp.resultset_1?.[0];
    
    if (!updatedUser) {
      const respErro = resp[0]?.message ?? "Resposta inválida do servidor";
      throw new Error(respErro);
    }

    const raw = localStorage.getItem("authUser");    
    const prev = raw ? JSON.parse(raw) : {};

    const merged = {
      ...prev,
      resultset_2: [ updatedUser ],
      resultset_1: prev.resultset_1,
      resultset_3: prev.resultset_3,
      resultset_4: prev.resultset_4,
    };

    localStorage.setItem("authUser", JSON.stringify(merged));
    
    yield put(loginUpdate(updatedUser));
    yield put(profileSuccess(message));

  } catch (err) {
    const message =
      (typeof err.response?.data === "string" && err.response.data.trim()) ||
      err.response?.data?.message ||
      JSON.stringify(err.response?.data) ||
      err.message ||
      String(err);

    yield put(profileError(message));
  }
}

function* editLogin({ payload: { userLogin } }) {
  try {
    const paramsData = {
      Email: userLogin.Novo_Email,
      Token: userLogin.Token,
    };

    const resp = yield call(
      BizinBackend.executeProcedure,
      paramsData,
      "FRONT_Workspace_Confirmar_Alteracao_Email",
      userLogin._csrf,
      userLogin._access_token_msman
    );

    const message = resp[0]?.message;
    if (resp[0]?.statusCode !== 200) {
      throw new Error(message);
    }

    const raw = localStorage.getItem("authUser");
    const prev = raw ? JSON.parse(raw) : {};

    const updatedResultset2 = prev.resultset_2.map((item, idx) =>
      idx === 0
        ? { ...item, Email: userLogin.Novo_Email }
        : item
    );
    
    const merged = {
      ...prev,
      resultset_2: updatedResultset2,
      resultset_1: prev.resultset_1,
      resultset_3: prev.resultset_3,
      resultset_4: prev.resultset_4,
    };

    localStorage.setItem("authUser", JSON.stringify(merged));
    yield put(loginUpdate(merged));
    yield put(loginSuccess(merged, merged?.resultset_2[0]));
    yield put(profileSuccess(message));
    

  } catch (err) {
    const errorMsg =
      err.response?.data?.message ||
      err.response?.data ||
      err.message ||
      String(err);
    yield put(profileError(errorMsg));
  }
}

export function* watchProfile() {
   yield takeEvery(EDIT_PROFILE, editProfile)
   yield takeEvery(EDIT_AVATAR, editAvatar)
   yield takeEvery(EDIT_LOGIN, editLogin)
}

function* ProfileSaga() {
  yield all([fork(watchProfile)])
}

export default ProfileSaga
